export enum AssistedSalesActionType {
  ImpersonationProceedToCheckout = 'Checkout',
  ImpersonationShareLink = 'Share Link',
  ImpersonationPaymentLinkShared = 'Shared Payment Link',
  ImpersonationOrderHistory = 'Order History',
  ImpersonationDigitalAccountCreation = 'Account Creation',
  ImpersonationLogin = 'Impersonate Login',
}

export enum ImpersonationEventsLabel {
  EmployeeLogoutSuccess = 'Logout Button Click',
  ImpersonationLoginSuccess = 'Success - Impersonation Login',
  ImpersonationLogoutSuccess = 'Success - Impersonation Logout',
  ImpersonationOrderHistory = 'Order History Button Click',
  ImpersonationProceedToCheckoutSuccess = 'Share Link Click',
  ImpersonationProceedToCheckoutFail = 'Share Link Cancel',
  ImpersonationShareLink = 'Share Button Click',
  ImpersonationPaymentLinkRedirectSuccess = 'Success - Payment Link Redirect',
  ImpersonationDigitalAccountSuccess = 'Success - Digital Account Created',
  ImpersonationDigitalAccountError = 'Error - Digital Account not Created',
  ImpersonationPaymentLinkShareSuccess = 'Success - Shared payment link',
}
